var _style, _path, _g, _g2, _g3, _g4, _g5, _g6, _circle, _circle2, _g7, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassionflowerTea({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF9062;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#F4A38B;}\n\t.st3{fill:none;stroke:#B92555;stroke-width:2.4651;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.21,182.55c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.91,148.26,62.52,182.55,105.21,182.55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.64,83.12l-2.27,0.74l-0.82,16.55l1.26,0.67c0,0,3.21,2.55,4.13-4.15c0.14-1,1.02-2.22,1.53-3.04 c1.05-1.68,2.47-3.42,4.4-4.09c1.51-0.53,3.08-0.2,4.42,0.61c4.16,2.5,4.82,6.83,4.06,11.35c-0.68,4.05-2.6,7.8-5.46,10.75 c-4.6,4.75-11.06,7.25-17.4,8.65c-0.65,0.14-1.31,0.28-1.97,0.4c4.17-11.48,7.59-26.41,6.19-42.61h-1.05 c0.93-0.55,1.42-1.11,1.42-1.71c0-3.53-18.05-6.38-40.31-6.38c-22.29,0-40.36,2.85-40.36,6.38c0,0.6,0.5,1.16,1.44,1.71h-1.33 c0,0-3.48,37.47,18.16,66.35c0,0,21.34,10.65,44.83-1.22c0,0,2.15-3.15,4.97-8.62c1.38-0.62,3.76-1.88,7.77-4.39 c0,0,25.92-10.65,28.2-24.07C163.45,107,170.94,74.81,141.64,83.12z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.42,
    y: 77.05,
    className: "st1",
    width: 2.54,
    height: 5.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.54,
    y: 77.08,
    className: "st1",
    width: 2.54,
    height: 12.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8304 -0.5571 0.5571 0.8304 -37.3378 66.0009)",
    className: "st2",
    cx: 89.75,
    cy: 94.33,
    rx: 4.4,
    ry: 8.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8304 -0.5571 0.5571 0.8304 -49.2023 80.5417)",
    className: "st2",
    cx: 107.7,
    cy: 121.09,
    rx: 4.4,
    ry: 8.41
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0632 -0.998 0.998 0.0632 1.9873 185.386)",
    className: "st2",
    cx: 99.74,
    cy: 91.63,
    rx: 8.41,
    ry: 4.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0632 -0.998 0.998 0.0632 -32.0173 213.4794)",
    className: "st2",
    cx: 97.71,
    cy: 123.79,
    rx: 8.41,
    ry: 4.4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9637 -0.2669 0.2669 0.9637 -23.4563 34.2454)",
    className: "st2",
    cx: 114.25,
    cy: 103.41,
    rx: 8.41,
    ry: 4.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9637 -0.2669 0.2669 0.9637 -26.8784 26.2687)",
    className: "st2",
    cx: 83.2,
    cy: 112.01,
    rx: 8.41,
    ry: 4.4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6424 -0.7664 0.7664 0.6424 -60.4094 110.6663)",
    className: "st2",
    cx: 88.38,
    cy: 120.06,
    rx: 8.41,
    ry: 4.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6424 -0.7664 0.7664 0.6424 -34.0795 117.6991)",
    className: "st2",
    cx: 109.08,
    cy: 95.37,
    rx: 8.41,
    ry: 4.4
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3185 -0.9479 0.9479 0.3185 -40.3671 149.0181)",
    className: "st2",
    cx: 83.45,
    cy: 102.58,
    rx: 4.4,
    ry: 8.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3185 -0.9479 0.9479 0.3185 -29.2782 184.9686)",
    className: "st2",
    cx: 114,
    cy: 112.85,
    rx: 4.4,
    ry: 8.41
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 98.73,
    cy: 107.71,
    r: 9.67
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 98.73,
    cy: 107.71,
    r: 6.92
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 100.99,
    y1: 96.53,
    x2: 96.82,
    y2: 119.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 95.45,
    y1: 96.53,
    x2: 102,
    y2: 118.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 109.12,
    y1: 102.45,
    x2: 88.59,
    y2: 113.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 105.68,
    y1: 98.1,
    x2: 92.26,
    y2: 117.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 106.23,
    y1: 116.71,
    x2: 91.23,
    y2: 98.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 109.77,
    y1: 112.43,
    x2: 88.37,
    y2: 103.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 86.18,
    y1: 108.39,
    x2: 111.27,
    y2: 107.3
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 98.73,
    cy: 107.71,
    r: 3.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.12,119.66c0,0-0.16,0.11-0.37,0.24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassionflowerTea);
export default __webpack_public_path__ + "static/media/Passionflower_tea.41124d7e13d5b9d41c838c07124605da.svg";
export { ForwardRef as ReactComponent };